<div class="px-1 pb-8">
  <!-- Loading -->
  <div *ngIf="isLoading" class="flex items-center justify-center py-16">
    <mat-progress-spinner color="primary" mode="indeterminate" diameter="40"></mat-progress-spinner>
  </div>

  <ng-container *ngIf="!isLoading && mandat">
    <div class="grid grid-cols-1 gap-5 lg:grid-cols-3">
      <!-- Column 1: all data (2/3) -->
      <div class="lg:col-span-2">
        <!-- Header -->
        <div class="flex items-center justify-between gap-3 mb-6">
          <div>
            <p class="text-xs font-medium uppercase tracking-wide text-gray-400">Aktenzeichen</p>
            <h2 class="text-xl font-semibold text-gray-900 leading-tight">{{ mandat.Md_BelegNr }}</h2>
          </div>
          <div class="flex items-center gap-2">
            <span
              class="inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold"
              [ngClass]="statusBadgeClass(mandat.Md_Status)">
              {{ statusLabel(mandat.Md_Status) }}
            </span>
            <span
              class="inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold"
              [ngClass]="+mandat.bom === 1 ? 'bg-green-100 text-green-700' : 'bg-blue-100 text-blue-700'">
              {{ bomLabel(mandat.bom) }}
            </span>
          </div>
        </div>

        <!-- Kennzeichen / Fahrzeug -->
        <div class="rounded-xl border border-gray-200 bg-white shadow-sm mb-5">
          <div class="rounded-t-xl border-b border-gray-200 bg-gray-50 px-4 py-2">
            <h3 class="card-title text-gray-700">Kennzeichen / Fahrzeug</h3>
          </div>
          <dl class="grid grid-cols-2 gap-x-6 gap-y-4 px-4 py-4 sm:grid-cols-3">
            <div>
              <dt class="text-xs uppercase tracking-wide text-gray-400">Land</dt>
              <dd class="mt-0.5 text-sm font-medium text-gray-900">{{ mandat.Md_KzLand || '–' }}</dd>
            </div>
            <div>
              <dt class="text-xs uppercase tracking-wide text-gray-400">Bezirk</dt>
              <dd class="mt-0.5 text-sm font-medium text-gray-900">{{ mandat.Md_KzBezirk || '–' }}</dd>
            </div>
            <div>
              <dt class="text-xs uppercase tracking-wide text-gray-400">Nummer</dt>
              <dd class="mt-0.5 text-sm font-medium text-gray-900">{{ mandat.Md_KzNummer || '–' }}</dd>
            </div>
            <div>
              <dt class="text-xs uppercase tracking-wide text-gray-400">Hersteller</dt>
              <dd class="mt-0.5 text-sm font-medium text-gray-900">{{ mandat.Md_Hersteller || '–' }}</dd>
            </div>
            <div>
              <dt class="text-xs uppercase tracking-wide text-gray-400">Farbe</dt>
              <dd class="mt-0.5 text-sm font-medium text-gray-900">{{ mandat.Md_Farbe || '–' }}</dd>
            </div>
            <div>
              <dt class="text-xs uppercase tracking-wide text-gray-400">Fahrzeugart</dt>
              <dd class="mt-0.5 text-sm font-medium text-gray-900">{{ mandat.fahrzeugart || '–' }}</dd>
            </div>
          </dl>
        </div>

        <!-- Tatdaten -->
        <div class="rounded-xl border border-gray-200 bg-white shadow-sm mb-5">
          <div class="rounded-t-xl border-b border-gray-200 bg-gray-50 px-4 py-2">
            <h3 class="card-title text-gray-700">Tatdaten</h3>
          </div>
          <dl class="grid grid-cols-2 gap-x-6 gap-y-4 px-4 py-4 sm:grid-cols-3">
            <div>
              <dt class="text-xs uppercase tracking-wide text-gray-400">Datum von</dt>
              <dd class="mt-0.5 text-sm font-medium text-gray-900">{{ mandat.Md_Datum || '–' }}</dd>
            </div>
            <div>
              <dt class="text-xs uppercase tracking-wide text-gray-400">Zeit von</dt>
              <dd class="mt-0.5 text-sm font-medium text-gray-900">{{ mandat.Md_ZeitVon || '–' }}</dd>
            </div>
            <div>
              <dt class="text-xs uppercase tracking-wide text-gray-400">Datum bis</dt>
              <dd class="mt-0.5 text-sm font-medium text-gray-900">{{ mandat.tatzeit_bis_datum || '–' }}</dd>
            </div>
            <div>
              <dt class="text-xs uppercase tracking-wide text-gray-400">Zeit bis</dt>
              <dd class="mt-0.5 text-sm font-medium text-gray-900">{{ mandat.tatzeit_bis_uhrzeit || mandat.Md_ZeitBis || '–' }}</dd>
            </div>
            <div>
              <dt class="text-xs uppercase tracking-wide text-gray-400">Straße</dt>
              <dd class="mt-0.5 text-sm font-medium text-gray-900">{{ mandat.Md_Strasse || '–' }}</dd>
            </div>
            <div>
              <dt class="text-xs uppercase tracking-wide text-gray-400">Hausnummer</dt>
              <dd class="mt-0.5 text-sm font-medium text-gray-900">{{ mandat.Md_HausNr || '–' }}{{ mandat.Md_HausNrZusatz }}</dd>
            </div>
            <div>
              <dt class="text-xs uppercase tracking-wide text-gray-400">Delikt / VSTV-Code</dt>
              <dd class="mt-0.5 text-sm font-medium text-gray-900">{{ formatVSTVCode(mandat.Md_TatbestNr) || '–' }}</dd>
            </div>
            <div>
              <dt class="text-xs uppercase tracking-wide text-gray-400">Betrag</dt>
              <dd class="mt-0.5 text-sm font-medium text-gray-900">{{ mandat.Md_Betrag || '–' }}</dd>
            </div>
            <div>
              <dt class="text-xs uppercase tracking-wide text-gray-400">Dienst-Nr</dt>
              <dd class="mt-0.5 text-sm font-medium text-gray-900">{{ mandat.Md_DienstNr || '–' }}</dd>
            </div>
            <div class="col-span-2 sm:col-span-3">
              <dt class="text-xs uppercase tracking-wide text-gray-400">Person</dt>
              <dd class="mt-0.5 text-sm font-medium text-gray-900">{{ mandat.person || '–' }}</dd>
            </div>
          </dl>
        </div>

        <!-- Anmerkungen -->
        <div class="rounded-xl border border-gray-200 bg-white shadow-sm">
          <div class="rounded-t-xl border-b border-gray-200 bg-gray-50 px-4 py-2">
            <h3 class="card-title text-gray-700">Anmerkungen</h3>
          </div>
          <div class="space-y-4 px-4 py-4">
            <div>
              <p class="text-xs uppercase tracking-wide text-gray-400 mb-1">Anmerkungen</p>
              <p class="whitespace-pre-wrap break-words rounded-lg bg-gray-50 px-3 py-2 text-sm text-gray-800 min-h-[2.25rem]">{{ mandat.notes || '–' }}</p>
            </div>
            <div>
              <p class="text-xs uppercase tracking-wide text-gray-400 mb-1">Interne Notizen</p>
              <p class="whitespace-pre-wrap break-words rounded-lg bg-gray-50 px-3 py-2 text-sm text-gray-800 min-h-[2.25rem]">{{ mandat.interne_notes || '–' }}</p>
            </div>
            <div>
              <p class="text-xs uppercase tracking-wide text-gray-400 mb-1">Freitext</p>
              <p class="whitespace-pre-wrap break-words rounded-lg bg-gray-50 px-3 py-2 text-sm text-gray-800 min-h-[2.25rem]">{{ mandat.freitext || '–' }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Column 2: images (1/3) -->
      <div class="lg:col-span-1">
        <div class="rounded-xl border border-gray-200 bg-white shadow-sm lg:sticky lg:top-2">
          <div class="flex items-center justify-between rounded-t-xl border-b border-gray-200 bg-gray-50 px-4 py-2">
            <h3 class="card-title text-gray-700">Bilder</h3>
            <span class="inline-flex items-center rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-600">
              {{ mandatImages.length }}
            </span>
          </div>

          <div class="px-4 py-4">
            <p *ngIf="mandatImages.length === 0" class="text-sm text-gray-400">
              Keine Bilder zu diesem Mandat vorhanden.
            </p>

            <div *ngIf="mandatImages.length > 0" class="flex flex-col gap-3">
              <div
                *ngFor="let img of mandatImages; let i = index"
                class="group relative cursor-pointer overflow-hidden rounded-lg border border-gray-200 bg-gray-50"
                (click)="openImageInNewWindow(img.filename)">
                <img
                  src="{{ imageStorage }}img?f={{ img.filename }}"
                  alt="Foto {{ i + 1 }}"
                  class="aspect-[4/3] w-full object-cover transition-transform duration-200 group-hover:scale-105" />
                <div class="pointer-events-none absolute inset-0 flex items-center justify-center bg-black/0 transition-colors duration-200 group-hover:bg-black/30">
                  <mat-icon class="text-white opacity-0 transition-opacity duration-200 group-hover:opacity-100">zoom_in</mat-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- Error / not found -->
  <div *ngIf="!isLoading && !mandat" class="rounded-lg bg-red-50 px-4 py-3 text-sm text-red-600">
    Mandat konnte nicht geladen werden.
  </div>
</div>
